/**
 * Download a RECEIVED attachment through the authenticated route.
 *
 * Not an `<a href>`: the route requires an `Authorization` header, and the
 * alternatives are both worse. A token in the query string is the defect
 * class #603/#637 already fixed once — secrets in URLs end up in logs,
 * referrers and browser history — and a session cookie would couple file
 * downloads to an auth mode this app does not primarily use.
 *
 * So the bytes are fetched with the header, wrapped in an object URL, and
 * handed to a synthetic anchor. The URL is revoked immediately afterwards:
 * the browser has already begun the save by then, and leaving it alive pins
 * the whole file in memory for the life of the tab.
 */
import axios from 'axios';

import { API } from '../../lib/api';

export async function downloadMailAttachment({ commId, attachment, getAuthHeader }) {
    const res = await axios.get(
        `${API}/mail/messages/${encodeURIComponent(commId)}`
        + `/attachments/${encodeURIComponent(attachment.attachment_id)}`,
        { responseType: 'blob', headers: getAuthHeader?.() || {} },
    );
    const url = URL.createObjectURL(res.data);
    try {
        const a = document.createElement('a');
        a.href = url;
        a.download = attachment.filename || 'attachment';
        document.body.appendChild(a);
        a.click();
        a.remove();
    } finally {
        URL.revokeObjectURL(url);
    }
}
